module.exports = __webpack_public_path__ + "static/img/松下微蒸烤炸一体机 DS37.92dde5c8.png";